import { requestLaravel } from "../../../../../../utils/api";
import { IProjectStatusAndReadiness, IGovernanceCompliance, IProcurementReadiness, IImplementationReadiness, IStakeholderCommunicationReadiness, IFinancingModel, IGovernancePolicy, IPartnerAgency, IEconomicAndCommercialViability } from "./_models";
import { ApiResponse, IProjectDocument } from "../../../../core/_models";


export function updateStakeholderCommunicationReadiness(updateData: IStakeholderCommunicationReadiness & { project_id: number }) {
    return requestLaravel<ApiResponse<IStakeholderCommunicationReadiness>>(
        "/project-stage-three/stakeholder-communication-readiness/update",
        updateData
    );
}

export function getStakeholderCommunicationReadiness(project_id: number, signal?: AbortSignal) {
    return requestLaravel<ApiResponse<IStakeholderCommunicationReadiness>>(
        "/project-stage-three/stakeholder-communication-readiness/get",
        { project_id },
        { signal }
    );
}

export function getProjectStatusAndReadiness(project_id: string, signal?: AbortSignal) {
    return requestLaravel<ApiResponse<IProjectStatusAndReadiness>>(
        "/project-stage-three/project-status-readiness/get",
        { project_id },
        { signal }
    );
}

interface UpdateProjectStatusAndReadinessPayload extends IProjectStatusAndReadiness {
    project_id: number;
}

export function updateProjectStatusAndReadiness(updateData: UpdateProjectStatusAndReadinessPayload) {
    return requestLaravel<ApiResponse<IProjectStatusAndReadiness>>(
        "/project-stage-three/project-status-readiness/update",
        updateData
    );
}

export function getGovernanceCompliance(project_id: string, signal?: AbortSignal) {
    return requestLaravel<ApiResponse<IGovernanceCompliance>>(
        "/project-stage-three/governance-compliance/get",
        { project_id },
        { signal }
    );
}

interface UpdateGovernanceCompliancePayload extends IGovernanceCompliance {
    project_id: number;
}

export function updateGovernanceCompliance(updateData: UpdateGovernanceCompliancePayload) {
    return requestLaravel<ApiResponse<IGovernanceCompliance>>(
        "/project-stage-three/governance-compliance/update",
        updateData
    );
}

export function getProcurementReadiness(project_id: string, signal?: AbortSignal) {
    return requestLaravel<ApiResponse<IProcurementReadiness>>(
        "/project-stage-three/procurement-readiness/get",
        { project_id },
        { signal }
    );
}

interface UpdateProcurementReadinessPayload extends IProcurementReadiness {
    project_id: number;
}

export function updateProcurementReadiness(updateData: UpdateProcurementReadinessPayload) {
    return requestLaravel<ApiResponse<IProcurementReadiness>>(
        "/project-stage-three/procurement-readiness/update",
        updateData
    );
}

export function updateImplementationReadiness(updateData: IImplementationReadiness & { project_id: number }) {
    return requestLaravel<ApiResponse<IImplementationReadiness>>(
        "/project-stage-three/implementation-readiness/update",
        updateData
    );
}

export function getImplementationReadiness(project_id: number, signal?: AbortSignal) {
    return requestLaravel<ApiResponse<IImplementationReadiness>>(
        "/project-stage-three/implementation-readiness/get",
        { project_id },
        { signal }
    );
}

export function saveProjectStageThree(payload: { project_id: number; dk_stage: string }, signal?: AbortSignal) {
    return requestLaravel<ApiResponse<void>>(
        "/project-stage-three/stage/submit",
        { project_id: payload.project_id },
        { signal }
    );
}

export function getFeasibilityReadinessPercentage(payload: { project_id: number }, signal?: AbortSignal) {
    return requestLaravel<ApiResponse<{ readiness_percentage: number; average_risk_score: number }>>(
        "/project-stage-three/feasibility-readiness/get",
        payload,
        { signal }
    );
}

export interface IBfiAlternativeFinancingModel {
    id: number;
    [key: string]: string | number;
}

export function getBfiAlternativeFinancingModel(signal?: AbortSignal) {
    return requestLaravel<ApiResponse<{ list: IBfiAlternativeFinancingModel[] }>>(
        "/project-stage-three/bfi-alternative-financing-models/list",
        {},
        { signal }
    );
}


// Governance Policy & Enabling Environment
export function getGovernancePolicyEnablingEnvironment(project_id: string, signal?: AbortSignal) {
    return requestLaravel<ApiResponse<IGovernancePolicy>>(
        "/project-stage-three/governance-policy-enabling-environment/get",
        { project_id },
        { signal }
    );
}

export function updateGovernancePolicyEnablingEnvironment(updateData: IGovernancePolicy & { project_id: number }) {
    return requestLaravel<ApiResponse<IGovernancePolicy>>(
        "/project-stage-three/governance-policy-enabling-environment/update",
        updateData
    );
}

export function getProjectStagePartnerAgency(project_id: string, signal?: AbortSignal) {
    return requestLaravel<ApiResponse<IPartnerAgency[]>>(
        "/project-stage-three/partner-agencies/list",
        { project_id },
        { signal }
    );
}

export function storeOrUpdateProjectStagePartnerAgency(updateData: IPartnerAgency & { project_id: number }) {
    return requestLaravel<ApiResponse<IPartnerAgency>>(
        "/project-stage-three/partner-agencies/save",
        updateData
    );

}

export function deleteProjectStagePartnerAgency(payload: { project_id: number; partner_agency_id: number }) {
    return requestLaravel<ApiResponse<{ partner_agency_id: number }>>(
        "/project-stage-three/partner-agencies/delete",
        payload
    );

}


/* =========================
   MINI EDITOR
========================= */

function updateProjectStage3MiniEditor<TResponse, TPayload extends { project_id: number }>(
    updateData: TPayload,
    signal?: AbortSignal
) {
    // return stageThreeRequest<TResponse>(
    //     "updateProjectStage3MiniEditor",
    //     updateData,
    //     { signal }
    // );
    return requestLaravel<ApiResponse<TResponse>>(
        "/project-stage-three/mini-editor/update",
        updateData,
        { signal }
    );
}

function getProjectStage3MiniEditor<TResponse, TPayload extends { project_id: number }>(
    payload: TPayload,
    signal?: AbortSignal
) {
    // return stageThreeRequest<TResponse>(
    //     "getProjectStage3MiniEditor",
    //     payload,
    //     { signal }
    // );
    return requestLaravel<ApiResponse<TResponse>>(
        "/project-stage-three/mini-editor/get",
        payload,
        { signal }
    );
}

interface UpdateEconomicAndCommercialViabilityPayload extends IEconomicAndCommercialViability {
    project_id: number;
}

export function getEconomicAndCommercialViability(payload: UpdateEconomicAndCommercialViabilityPayload, signal?: AbortSignal) {
    return getProjectStage3MiniEditor<IEconomicAndCommercialViability, UpdateEconomicAndCommercialViabilityPayload>(payload, signal);
}

export function updateEconomicAndCommercialViability(updateData: UpdateEconomicAndCommercialViabilityPayload) {
    return updateProjectStage3MiniEditor<IEconomicAndCommercialViability, UpdateEconomicAndCommercialViabilityPayload>(updateData);
}
